export const usmle1MicroModule = {
  id: "micro",
  title: "Microbiology",
  sections: [
    {
      type: "text",
      content:
        "Gram-negative bacteria have LPS endotoxin (lipid A). Gram-positive have teichoic acids.",
    },
    {
      type: "question",
      text: "Endotoxin is part of which structure?",
      options: ["LPS", "Peptidoglycan", "Teichoic acid", "Mycolic acid"],
      correct: 0,
      explanation: "Lipid A of LPS is endotoxin in Gram-negative bacteria.",
    },
  ],
};
